import React from 'react';
import './public/site.css';
import PublicHeader from './public/PublicHeader';
import PublicFooter from './public/PublicFooter';

const Privacy: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Chính sách bảo mật - Fconnect';
  }, []);
  return (
    <div className="home-page fc-site">
      <PublicHeader lang="vi" />

      {/* Content */}
      <section className="home-container">
        <header className="privacy-header">
          <h1>Chính sách Bảo mật</h1>
          <p className="last-updated">Cập nhật lần cuối: {new Date().toLocaleDateString('vi-VN')}</p>
        </header>
        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Giới thiệu</h2>
            <p>
              Chào mừng bạn đến với FConnect! Chúng tôi cam kết bảo vệ quyền riêng tư và thông tin cá nhân của bạn. 
              Chính sách bảo mật này giải thích cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ thông tin của bạn 
              khi sử dụng dịch vụ của chúng tôi.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Thông tin chúng tôi thu thập</h2>
            <h3>2.1 Thông tin cá nhân</h3>
            <ul>
              <li>Họ tên, địa chỉ email, số điện thoại</li>
              <li>Địa chỉ giao hàng và thanh toán</li>
              <li>Thông tin tài khoản và mật khẩu</li>
              <li>Ảnh đại diện và thông tin hồ sơ</li>
            </ul>

            <h3>2.2 Thông tin giao dịch</h3>
            <ul>
              <li>Lịch sử đặt hàng và thanh toán</li>
              <li>Thông tin dịch vụ đã sử dụng</li>
              <li>Đánh giá và nhận xét</li>
              <li>Thông tin liên lạc với nhà cung cấp dịch vụ</li>
            </ul>

            <h3>2.3 Thông tin kỹ thuật</h3>
            <ul>
              <li>Địa chỉ IP và vị trí địa lý</li>
              <li>Thông tin thiết bị và trình duyệt</li>
              <li>Cookies và dữ liệu sử dụng</li>
              <li>Nhật ký hoạt động trên ứng dụng</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. Cách chúng tôi sử dụng thông tin</h2>
            <ul>
              <li><strong>Cung cấp dịch vụ:</strong> Xử lý đơn hàng, kết nối với nhà cung cấp, hỗ trợ khách hàng</li>
              <li><strong>Cải thiện dịch vụ:</strong> Phân tích hành vi sử dụng, phát triển tính năng mới</li>
              <li><strong>Bảo mật:</strong> Ngăn chặn gian lận, bảo vệ tài khoản người dùng</li>
              <li><strong>Marketing:</strong> Gửi thông báo khuyến mãi, tin tức (với sự đồng ý của bạn)</li>
              <li><strong>Tuân thủ pháp luật:</strong> Đáp ứng yêu cầu của cơ quan có thẩm quyền</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Chia sẻ thông tin</h2>
            <p>Chúng tôi chỉ chia sẻ thông tin của bạn trong các trường hợp sau:</p>
            <ul>
              <li><strong>Với nhà cung cấp dịch vụ:</strong> Để thực hiện dịch vụ bạn đã đặt</li>
              <li><strong>Với đối tác thanh toán:</strong> Để xử lý giao dịch tài chính</li>
              <li><strong>Với cơ quan pháp luật:</strong> Khi có yêu cầu hợp pháp</li>
              <li><strong>Trong trường hợp khẩn cấp:</strong> Để bảo vệ an toàn của người dùng</li>
            </ul>
            <p>
              <strong>Chúng tôi cam kết không bán, cho thuê hay trao đổi thông tin cá nhân của bạn 
              với bất kỳ bên thứ ba nào vì mục đích thương mại.</strong>
            </p>
          </section>

          <section className="privacy-section">
            <h2>5. Bảo mật thông tin</h2>
            <p>Chúng tôi áp dụng các biện pháp bảo mật tiên tiến để bảo vệ thông tin của bạn:</p>
            <ul>
              <li>Mã hóa SSL/TLS cho tất cả dữ liệu truyền tải</li>
              <li>Mã hóa dữ liệu nhạy cảm trong cơ sở dữ liệu</li>
              <li>Xác thực đa yếu tố cho tài khoản quan trọng</li>
              <li>Kiểm soát truy cập nghiêm ngặt cho nhân viên</li>
              <li>Sao lưu dữ liệu định kỳ và an toàn</li>
              <li>Giám sát bảo mật 24/7</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>6. Quyền của người dùng</h2>
            <p>Bạn có các quyền sau đối với thông tin cá nhân của mình:</p>
            <ul>
              <li><strong>Quyền truy cập:</strong> Xem thông tin cá nhân chúng tôi lưu trữ</li>
              <li><strong>Quyền chỉnh sửa:</strong> Cập nhật hoặc sửa đổi thông tin không chính xác</li>
              <li><strong>Quyền xóa:</strong> Yêu cầu xóa thông tin cá nhân (trong một số trường hợp)</li>
              <li><strong>Quyền hạn chế:</strong> Giới hạn cách chúng tôi xử lý thông tin của bạn</li>
              <li><strong>Quyền di chuyển:</strong> Nhận bản sao dữ liệu của bạn ở định dạng có cấu trúc</li>
              <li><strong>Quyền phản đối:</strong> Từ chối việc xử lý thông tin cho mục đích marketing</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>7. Cookies và công nghệ theo dõi</h2>
            <p>Chúng tôi sử dụng cookies và các công nghệ tương tự để:</p>
            <ul>
              <li>Ghi nhớ thông tin đăng nhập và tùy chọn của bạn</li>
              <li>Phân tích cách sử dụng website và ứng dụng</li>
              <li>Cá nhân hóa nội dung và quảng cáo</li>
              <li>Cải thiện hiệu suất và trải nghiệm người dùng</li>
            </ul>
            <p>
              Bạn có thể quản lý cookies thông qua cài đặt trình duyệt của mình. 
              Tuy nhiên, việc tắt cookies có thể ảnh hưởng đến chức năng của dịch vụ.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Lưu trữ dữ liệu</h2>
            <p>Chúng tôi lưu trữ thông tin của bạn:</p>
            <ul>
              <li>Trong thời gian bạn sử dụng dịch vụ</li>
              <li>Thêm một khoảng thời gian hợp lý sau khi bạn ngừng sử dụng</li>
              <li>Theo yêu cầu của pháp luật về lưu trữ dữ liệu</li>
              <li>Cho đến khi bạn yêu cầu xóa (trong các trường hợp được phép)</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>9. Trẻ em và quyền riêng tư</h2>
            <p>
              Dịch vụ của chúng tôi không dành cho trẻ em dưới 13 tuổi. Chúng tôi không cố ý 
              thu thập thông tin cá nhân từ trẻ em dưới 13 tuổi. Nếu chúng tôi phát hiện đã thu thập 
              thông tin như vậy, chúng tôi sẽ xóa ngay lập tức.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Cập nhật chính sách</h2>
            <p>
              Chúng tôi có thể cập nhật chính sách bảo mật này theo thời gian. Khi có thay đổi quan trọng, 
              chúng tôi sẽ thông báo cho bạn qua email hoặc thông báo trên ứng dụng. 
              Việc tiếp tục sử dụng dịch vụ sau khi thay đổi có nghĩa là bạn chấp nhận chính sách mới.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. Liên hệ</h2>
            <p>
              Nếu bạn có bất kỳ câu hỏi nào về chính sách bảo mật này hoặc muốn thực hiện các quyền của mình, 
              vui lòng liên hệ với chúng tôi:
            </p>
                         <div className="contact-info">
               <p><strong>Email:</strong> trile@fconnect.vn</p>
               <p><strong>Điện thoại:</strong> 02513684266</p>
               <p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc, Phường Trấn Biên, Tp. Đồng Nai, Việt Nam</p>
               <p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
             </div>
          </section>
        </div>
      </section>

      <PublicFooter lang="vi" />
    </div>
  );
};

export default Privacy; 